import { render } from "./fileManeger2.vue?vue&type=template&id=44d0302c"
import script from "./fileManeger2.vue?vue&type=script&lang=js"
export * from "./fileManeger2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__